export default "__VITE_ASSET__AViYG6cK__"